export default "/images/vendor/flag-icons/flags/4x3/arab.svg?df48a3462c9c85d435122b116268b453";